import { StatusOfflineIcon } from "@heroicons/react/outline";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "~/design-system/Box";
import { Text } from "~/design-system/Text";

type UncachedDataOfflinePlaceholderProps = {
  unavailable?: boolean;
};

export const UncachedDataOfflinePlaceholder = ({
  unavailable = false,
}: UncachedDataOfflinePlaceholderProps) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="full"
      padding="large"
      css={{
        backgroundColor: "$colors$background",
      }}
    >
      <Box css={{ marginBottom: "$space$xxsmall" }}>
        <StatusOfflineIcon height={87} width={87} color="#8E8E8E" />
      </Box>
      <Text
        size="large"
        css={{
          color: "#183566",
          marginBottom: "$space$xsmall",
          textAlign: "center",
        }}
      >
        {t(
          "screens.App.components.UncachedDataScreen.title",
          "You are offline"
        )}
      </Text>
      <Text
        size="small"
        css={{
          color: "#183566",
          maxWidth: "600px",
          textAlign: "center",
        }}
      >
        {unavailable
          ? t(
              "screens.App.components.UncachedDataScreen.unavailable",
              "This content is currently not available offline."
            )
          : t(
              "screens.App.components.UncachedDataScreen.unCached",
              "This content hasn't been cached yet. Please visit this page while online first to make it available offline."
            )}
      </Text>
    </Box>
  );
};
